import React from 'react';
import { useTranslation } from 'react-i18next';

export const Footer = ({ items, containerWide }) => {
  const { t } = useTranslation();

  const handleUsercentricsCookieClick = (event) => {
    event.preventDefault();
    window.UC_UI.showSecondLayer();
  };

  return (
    <div className="ct-footer">
      {items && (
        <ul className={`ct-footer__content${containerWide ? ' ct-footer__content--wide' : ''}`}>
          {items.map((item, index) => (
            <li key={index} className="ct-footer__list-elem">
              {item.href ? (
                <a href={item.href} target="_blank" rel="noreferrer noopener" className="ct-footer__list-elem--link">
                  {item.text}
                </a>
              ) : (
                item.text
              )}
            </li>
          ))}
          {window.UC_UI && (
            <li onClick={handleUsercentricsCookieClick} className="ct-footer__list-elem">
              <a href="#" className="ct-footer__list-elem--link">
                {t('usercentrics_cookie')}
              </a>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
